/**
 * 附件模块接口列表
 */
import Vue from "vue"
import axios from '@/utils/http'; // 导入http中创建的axios实例
const appendix = {
  //下载ca
    ca(params) {
      return axios.get(`${Vue.prototype.$base.API_PATH_OPEN}/appendix/ca`, {
          params: params,
          responseType: 'blob',//文件流下载类型
        });
    },
    //验证供应商信息是否正确
    upload(params, options) {
        return axios.post(`${Vue.prototype.$base.API_PATH}/appendix`,params,{
            onUploadProgress: progressEvent => {
                // 这里可以获取上传进度并更新进度条
                const percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);
                options.onProgress({ percent: percentCompleted }); // 更新进度
              }
        }).then(response => {
            options.onSuccess(response.data);
          }).catch(error => {
            options.onError(error);
          });
    },
  //下载文件对外开放得文件
  download(fileName) {
    return axios.get(`${Vue.prototype.$base.API_PATH_OPEN}/open/appendix`, {
      params: {
        file:fileName
      },
      responseType: 'blob',//文件流下载类型
    });
  },
}

export default appendix;



// WEBPACK FOOTER //
// ./src/api/appendix.js